export default {
    error_title: 'Erro!',
    warning_title: 'Atenção!',
    wrong_input_title: 'Campos incorretos!',
    action_not_done: 'Ação não realizada!',
    error_asaas_payment: {
        invalid_value: 'O valor mínimo para cobranças via Cartão de Crédito é R$ 5,00.',
        invalid_billingType: 'A forma de pagamento não é permitida para assinaturas.',
    },
    without_connection: {
        title: 'Problema ao se Conectar com o Servidor',
        message: 'Verifique se está conectado a internet.',
    },
    unexpected: {
        title: 'Erro inesperado!',
        message: 'Ocorreu um erro inesperado no servidor, por favor tente novamente.'
    },
    maintenance: {
        title: 'Em manutenção!',
        message: 'Desculpe, estamos em manutenção no momento, tente novamente após alguns minutos.'
    },
    recaptcha: {
        alert_title: 'Problema com ReCaptcha',
        alert_body: 'Nosso site é protegido pelo ReCaptcha do google, mas no momento não foi possivel verificar se o seu navegador é seguro. ' +
            'Por favor tente novamente, se o problema persistir entre em contato.',
        refresh: 'Erro para obter o ReCaptcha Token. Atualize a página.',
    },
    imap_connection: {
        title: 'Não foi possível conectar no servidor IMAP!',
        message: 'Não foi possível conectar no servidor IMAP usando os dados inseridos no formulário. ' +
            'Verifique os dados do formulário e tente novamente.',
    },
    '400': 'Problema na requisição, tente novamente.',
    '401': 'Sessão encerrada, realize o login novamente.',
    '403': 'Você não possui permissão para executar essa ação.',
    '404': 'Registro não localizado',
    '419': 'Seção expirada, atualize a página.',
    '422': 'Corrija os erros dos campos do formulário.',
    '429': 'Muitas requisições em poucos segundos. Por favor aguarde alguns segundos e tente novamente.',
}
